var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "app/translate/translate.service";
import { FilterFormService } from "app/views/filter_form/filter_form.service";
import { HttpClient } from "@angular/common/http";
import { ChartParams } from "app/views/chart/chart.component";
import { EventsService } from "app/lib/EventsService";
import * as qs from 'qs';
import { BaseComponent } from "app/views/base.component";
import { ModalService } from "app/views/modal/base_modal.component";
import { PaidDetailsComponent } from "app/views/modal/paid_details/paid_details.component";
import { PromocodeInfoComponent } from "./details/promocode_info/promocode_info.component";
import { MoneyDetailsComponent } from "app/billing/billing/details/money_details/money_details.component";
import { getTimeAsIntervals } from "app/lib/lib";
import { HelperService } from "app/lib/helper.service";
import { BillingService2 } from "../billing.service";
var BillingComponent = /** @class */ (function (_super) {
    __extends(BillingComponent, _super);
    function BillingComponent(eventsService, activatedRoute, translate, router, modalService, filter, http, helper, service2) {
        var _this = _super.call(this, eventsService, service2, activatedRoute, filter, translate) || this;
        _this.eventsService = eventsService;
        _this.activatedRoute = activatedRoute;
        _this.translate = translate;
        _this.router = router;
        _this.modalService = modalService;
        _this.filter = filter;
        _this.http = http;
        _this.helper = helper;
        _this.service2 = service2;
        _this.totalLoader = false;
        _this.total2Loader = false;
        _this.paginationLoader = false;
        _this.statsLoader = false;
        _this.trialChart = new ChartParams();
        _this.paidChart = new ChartParams();
        _this.dontLoad = {};
        _this.addFilterParams = {
            userType: 'user',
            isBilling: true,
            dateFilters: ['dateCreated', 'datePaid', 'dateSiteCreated', 'dateTo', 'datePublished'],
            dateType: 'datePaid'
        };
        _this.hideZeroColumns = true;
        _this.filter.addFilters.push('promocode');
        _this.paidChart.setOptions({
            title: 'График оплат',
            names: {
                'paidCount': _this.translate.__A('common.paidCount'),
                'paidSiteCount': _this.translate.__A('billing.billing.paidSiteCount'),
                'paidFirstErrorCount': _this.translate.__A('billing.billing.paidFirstErrorCount'),
                'paidSecondErrorCount': _this.translate.__A('billing.billing.paidSecondErrorCount'),
                'uberCount': _this.translate.__A('billing.billing.uberCount'),
                'cashlessCount': _this.translate.__A('billing.billing.cashlessCount'),
                'trialToPaid': _this.translate.__A('billing.billing.trialToPaid'),
                'recurrentCount': _this.translate.__A('billing.billing.recurrentCount'),
                'randomDoubleManulaPaid': _this.translate.__A('billing.billing.randomDoubleManulaPaid'),
                'promocodeCount': _this.translate.__A('common.Promocode'),
                'firstPaidCount': _this.translate.__A('billing.billing.firstPaidCount'),
                'repeatPaidCount': _this.translate.__A('billing.billing.repeatPaidCount'),
                'firstRecCount': _this.translate.__A('billing.billing.firstRecurrentCount'),
                'secondRecurrentCount': _this.translate.__A('billing.billing.secondRecurrentCount'),
                'userManualErrorCount': _this.translate.__A('billing.billing.userManualErrorCount'),
                'userRecurrentErrorCount': _this.translate.__A('billing.billing.userRecurrentErrorCount'),
                'firstRecurrentCount': _this.translate.__A('billing.billing.firstRecurrentCount'),
            },
            colors: {
                'firstPaidCount': '#ff7f0e',
                'repeatPaidCount': '#2ca02c',
                'firstRecurrentCount': '#d62728',
                'secondRecurrentCount': '#9467bd',
                'paidSiteCount': '#8c564b',
                'recurrentCount': '#e377c2',
                'paidFirstErrorCount': '#8001FF',
                'paidSecondErrorCount': '#a3107c',
                'promocodeCount': '#bcbd22',
                'uberCount': '#17becf',
                'userRecurrentErrorCount': '#0000ff',
            },
            showLabels: [
                'firstPaidCount', 'repeatPaidCount', 'paidSiteCount', 'promocodeCount',
                'userManualErrorCount', 'userRecurrentErrorCount',
            ],
            isChartFilter: true
        });
        return _this;
    }
    BillingComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getTotal()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getTrialChart()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.getPaidChart()];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.getTotal2()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.getPagination()];
                    case 5:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // Получить данные для тотала (дополнительного)
    BillingComponent.prototype.getTotal = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.dontLoad.total)
                            return [2 /*return*/, true];
                        this.total = null;
                        if (!this.filter.filterParams.isShowBillingAdd)
                            return [2 /*return*/, true];
                        this.totalLoader = true;
                        _a = this;
                        return [4 /*yield*/, this.service2.siteBilling.total(this.filter.filterParams).toPromise()];
                    case 1:
                        _a.total = _b.sent();
                        this.totalLoader = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    // Получить данные для графика по триалам
    BillingComponent.prototype.getTrialChart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var charts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.dontLoad.trialChart) {
                            return [2 /*return*/, true];
                        }
                        if (!this.filter.filterParams.isShowBillingPeriod) {
                            return [2 /*return*/, true];
                        }
                        this.trialChart.showLoader();
                        return [4 /*yield*/, this.service2.siteBilling.chart(this.filter.filterParams, 'trialchart').toPromise()];
                    case 1:
                        charts = (_a.sent()).charts;
                        this.trialChart.data = charts;
                        this.trialChart.hideLoader();
                        this.trialChart.setOptions(__assign({}, new ChartParams().options, { names: {
                                count: this.translate.__A('billing.billing.trialToPaid'),
                            } }));
                        return [2 /*return*/];
                }
            });
        });
    };
    // Получить данные для графика
    BillingComponent.prototype.getPaidChart = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var charts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.dontLoad.paidChart) {
                            return [2 /*return*/, true];
                        }
                        this.paidChart.showLoader();
                        return [4 /*yield*/, this.service2.siteBilling.chart(this.filter.getCopyFilterParams(params), 'paidchart').toPromise()];
                    case 1:
                        charts = (_a.sent()).charts;
                        this.paidChart.data = charts;
                        this.paidChart.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    // Получить данные для тотала
    BillingComponent.prototype.getTotal2 = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.dontLoad.total2)
                            return [2 /*return*/, true];
                        this.total2 = null;
                        this.total2Loader = true;
                        _a = this;
                        return [4 /*yield*/, this.service2.siteBilling.get(this.filter.filterParams, 'total2').toPromise()];
                    case 1:
                        _a.total2 = _b.sent();
                        this.total2Loader = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    // Получить данные для пагинации
    BillingComponent.prototype.getPagination = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, pagination;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        if (!me.dontLoad.pagination) return [3 /*break*/, 2];
                        return [4 /*yield*/, me.getStats()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 2:
                        if (!(me.filter.filterParams.period == 'summary')) return [3 /*break*/, 4];
                        return [4 /*yield*/, me.getStats()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 4:
                        me.paginationLoader = true;
                        return [4 /*yield*/, me.service2.siteBilling.pagination(this.filter.filterParams).toPromise()];
                    case 5:
                        pagination = _a.sent();
                        me.pagination.fill(pagination);
                        if (pagination) {
                            me.updateLinks(me.service2.siteBilling.getRealFullRoute());
                        }
                        me.paginationLoader = false;
                        return [4 /*yield*/, me.getStats()];
                    case 6:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // Получить данные для stats
    BillingComponent.prototype.getStats = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, stats, _i, _a, stat, dates;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        me = this;
                        me.statsLoader = true;
                        return [4 /*yield*/, me.service2.siteBilling.stats(me.filter.getCopyFilterParams({
                                paginationDate: me.pagination.getDate()
                            })).toPromise()];
                    case 1:
                        stats = (_b.sent()).stats;
                        me.stats = stats;
                        for (_i = 0, _a = me.stats; _i < _a.length; _i++) {
                            stat = _a[_i];
                            dates = getTimeAsIntervals({
                                timestamp: stat.timestamp,
                                period: me.filter.filterParams.period
                            });
                            if (dates.length === 2) {
                                stat.currentPeriod = dates[0] + '-' + dates[1];
                            }
                            else {
                                stat.currentPeriod = dates[0];
                            }
                            stat.day = new Date(stat.timestamp).getDay();
                            if (stat.currentPeriod == '') {
                                stat.currentPeriod = 'summary';
                            }
                        }
                        me.statsLoader = false;
                        me.dontLoad = {};
                        return [2 /*return*/];
                }
            });
        });
    };
    // Клик по пагинации
    BillingComponent.prototype.onPageChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                this.filter.filterParams.page = this.pagination.page;
                this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);
                params = this.filter.getApplyFilters(this.filter.filterParams), url = this.router.url.split('?')[0];
                params = qs.stringify(params, { encode: false });
                this.router.navigateByUrl(url + "?" + params, { relativeTo: this.activatedRoute });
                this.dontLoad = {
                    total: true,
                    trialChart: true,
                    paidChart: true,
                    total2: true,
                    chart: true,
                    pagination: true
                };
                return [2 /*return*/];
            });
        });
    };
    BillingComponent.prototype.downloadTrials = function () {
        window.location.href = this.service2.siteBilling.downloadFileRoute(this.filter.filterParams);
    };
    BillingComponent.prototype.showDetails = function (key, stat, count, paidType, currency) {
        return __awaiter(this, void 0, void 0, function () {
            var title, modalRef, stats, modalRef, stats, modalRef, stats;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        title = stat.currentPeriod + " - " + (key === 'moneyCount' ? count / 100 : count);
                        if (!(key === 'siteCount')) return [3 /*break*/, 2];
                        modalRef = this.modalService.open(PaidDetailsComponent, {
                            title: title,
                            divide: 10,
                            currentPage: 1,
                            totalCount: count,
                            params: this.filter.filterParams,
                            groupDate: stat.groupDate
                        }, { size: 'hg' });
                        return [4 /*yield*/, this.service2.siteBilling.detail(this.filter.getCopyFilterParams({
                                dateTime: stat.groupDate,
                                page: 1,
                                divide: 10
                            })).toPromise()];
                    case 1:
                        stats = (_a.sent()).stats;
                        modalRef.componentInstance.details = stats;
                        return [3 /*break*/, 6];
                    case 2:
                        if (!(key === 'moneyCount')) return [3 /*break*/, 4];
                        if (paidType && currency) {
                            title = stat.currentPeriod + ": " + this.__a('billing.billing.' + paidType) + " (" + count / 100 + " " + this.helper.currencyLabels[currency] + ")";
                        }
                        else if (paidType) {
                            title = stat.currentPeriod + ": " + this.__a('billing.billing.' + paidType) + " (" + count / 100 + " " + this.helper.currencyLabels['usd'] + ")";
                        }
                        modalRef = this.modalService.open(MoneyDetailsComponent, { title: title }, { size: 'hg' });
                        return [4 /*yield*/, this.service2.siteBilling.stats(this.filter.getCopyFilterParams({ paidType: paidType, currency: currency, dateTime: stat.groupDate, }), 'money').toPromise()];
                    case 3:
                        stats = (_a.sent()).stats;
                        modalRef.componentInstance.details = stats;
                        return [3 /*break*/, 6];
                    case 4:
                        if (!(key === 'promocodeCount')) return [3 /*break*/, 6];
                        modalRef = this.modalService.open(PromocodeInfoComponent, { title: title }, { size: 'hg' });
                        return [4 /*yield*/, this.service2.siteBilling.stats(this.filter.getCopyFilterParams({ dateTime: stat.groupDate, }), 'promocode').toPromise()];
                    case 5:
                        stats = (_a.sent()).stats;
                        modalRef.componentInstance.details = stats;
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    BillingComponent.prototype.updateData = function (filter, type) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(type === 'paidChart')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getPaidChart(filter)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    return BillingComponent;
}(BaseComponent));
export { BillingComponent };
